<template>
  <main class="page-content mb-auto w-100 text-center" aria-label="Content">
    <div class="section-wrap">
      <div class="section-content">
        <section class="section">
          <div class="header">
            <h1>
              Danke für
              <br />die Infos.
            </h1>
          </div>
          <div class="content">
            <div class="row content-center-group">
              <div class="p-0">Wir haben deine Angaben aufgenommen und werden sie versuchen so schnell wie möglich in unser Branchenbuch einzutragen.</div>
              <div class="button-group align-items-center justify-content-center mt-3 mb-5">
                <button class="btn btn-primary" style="width: 266px;" v-on:click="toCompaniesPage">Home</button>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  methods: {
    toCompaniesPage: function() {
      this.$router.push({ path: "list" });
    }
  }
};
</script>